module.exports = __webpack_public_path__ + "static/media/Icn-wav.16437ee8.svg";